import { useFormikContext } from "formik";
import { useEffect } from "react";
import { ConditionProps } from "../../../../interfaces/Customer";
import { customerKindEnum } from "../../../../utils";

type IProps = { setCondition?: Function };
export default function EConversionHandler({ setCondition }: IProps) {
  const { values, setFieldValue }: any = useFormikContext();

  useEffect(() => {
    setCondition &&
      setCondition((prevState: ConditionProps) => ({
        ...prevState,
        eConversion: values.customerDetail.eConversion,
      }));
    if (
      values.customerDetail.eConversion &&
      values.customerKindId === customerKindEnum.indivual
    ) {
      setFieldValue("customerKindId", customerKindEnum.corporate, false);
    }
  }, [values.customerDetail.eConversion, values.customerKindId]);
  return null;
}
